import React from "react";
import PagePlaceholder from "@/components/PagePlaceholder";

const make = (titleKey, testId) =>
    function PlaceholderPage() {
        return <PagePlaceholder titleKey={titleKey} testId={testId} />;
    };

// Admin
export const AdminDashboard   = make("nav.dashboard",      "page-admin-dashboard");
export const AdminKyc         = make("nav.kyc",            "page-admin-kyc");
export const AdminCategories  = make("nav.categories",     "page-admin-categories");
export const AdminMembers     = make("nav.members",        "page-admin-members");
export const AdminProviders   = make("nav.providers",      "page-admin-providers");
export const AdminOffers      = make("nav.offersApproval", "page-admin-offers");
export const AdminWallets     = make("nav.wallets",        "page-admin-wallets");
export const AdminCommissions = make("nav.commissions",    "page-admin-commissions");
export const AdminAudit       = make("nav.audit",          "page-admin-audit");
export const AdminDisputes    = make("nav.disputes",       "page-admin-disputes");

// Provider
export const ProviderDashboard = make("nav.dashboard", "page-provider-dashboard");
export const ProviderProfile   = make("nav.profile",   "page-provider-profile");
export const ProviderLocations = make("nav.locations", "page-provider-locations");
export const ProviderStaff     = make("nav.staff",     "page-provider-staff");
export const ProviderOffers    = make("nav.offers",    "page-provider-offers");
export const ProviderVerify    = make("nav.verify",    "page-provider-verify");
export const ProviderVisits    = make("nav.visits",    "page-provider-visits");

// Kiosk
export const KioskRegister = make("nav.kioskRegister", "page-kiosk-register");
export const KioskWallet   = make("nav.myWallet",      "page-kiosk-wallet");
export const KioskSales    = make("nav.mySales",       "page-kiosk-sales");

// Member
export const MemberHome   = make("nav.home",     "page-member-home");
export const MemberCard   = make("nav.myCard",   "page-member-card");
export const MemberVisits = make("nav.myVisits", "page-member-visits");
